<template>
  <v-container fluid class="relative-position">
    <v-card :class="[fullForm ? '' : 'no-box-shadow modalIncidencias']">
      <v-card-title v-if="fullForm" :class="getColor(incidencia)" class="py-2">
        <div class="text-center width-100p">
          <div v-if="!isNew" class="headline text-center">
            {{ findLabel('incidenciaEstado',incidencia.Estado) }}
            <span
              v-if="incidencia.FechaCierreIncidencia"
              class="subheading"
            >
              &nbsp; {{ moment(incidencia.FechaCierreIncidencia).format('DD/MM/YYYY - HH:mm') }}
            </span>
          </div>
          <div v-else class="headline text-center">
            Nueva Incidencia
          </div>
        </div>
      </v-card-title>
      <v-divider v-if="fullForm" />
      <v-form :class="[fullForm ? 'layout row justify-center pa-3 pt-0' : '']">
        <v-container
          :class="[fullForm ? 'flex xs12 md11 lg10' : '']"
          fluid
          class="pa-0 relative-position"
        >
          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex v-if-tecnico :class="[fullForm ? 'py-1 xs12 md4' : 'py-1 px-2 xs12 md4']">
              <v-autocomplete ref="cliente" v-model="incidencia.Cliente" :disabled="!!incidencia.Incidencia || isDisabled"
                              :items="Clientes" :filter="selectFilterIncludes" :attach="!fullForm"
                              label="Cliente" item-text="label" item-value="value" class="select-inline"
                              clearable hide-details :auto-select-first="true"
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 md4' : 'py-1 px-2 xs12 md4']">
              <v-autocomplete v-model="instalacion" :disabled="!!incidencia.Incidencia || isDisabled"
                              :items="loadInstalaciones" :filter="selectFilterIncludes" :attach="!fullForm"
                              label="Instalación" item-text="label" item-value="value" class="select-inline"
                              clearable hide-details :auto-select-first="true"
              />
            </v-flex>
            <v-flex v-if="!fullForm" class="py-1 px-2">
              <v-text-field v-model="incidencia.ReportadaPor" :disabled="isDisabled"
                            label="Reportada por" hide-details
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="fullForm" v-if-tecnico align-space-between justify-start row fill-height wrap>
            <v-flex class="py-1 xs12 sm6 md4">
              <date-time v-model="incidencia.FechaIncidencia" :disabled="!!incidencia.Incidencia" />
            </v-flex>
            <v-flex v-if-tecnico class="py-1 xs12 sm6 md2 lg2">
              <v-text-field v-model="incidencia.TiempoEmpleado" :label-width="3"
                            disabled readonly label="Tiempo total" class="mt-1" hide-details
              />
            </v-flex>
          </v-layout>

          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex v-if="fullForm" :class="[fullForm ? 'py-1 xs12 sm6 md5 lg4': 'py-1 xs12 md4']">
              <v-text-field v-model="incidencia.ReportadaPor" :disabled="isDisabled"
                            label="Reportada por" class="mt-1" hide-details
              />
            </v-flex>
            <v-flex v-if="incidencia.Estado !== 'C'" :class="[fullForm ? 'py-1 xs12 sm6 md7 lg8': 'py-1 xs12 md8']">
              <v-autocomplete v-model="incidenciaPersonasContacto" :disabled="isDisabled" :items="personasContacto"
                              :filter="selectFilterIncludes" :attach="!fullForm" label="Personas de Contacto" item-text="label"
                              item-value="value" class="mt-1" multiple chips small-chips
                              clearable hide-details :auto-select-first="true" @input="setReportadaPor"
              >
                <template v-slot:selection="data">
                  <v-chip :selected="data.selected" close
                          @click.stop="copyEmail($event)" @input="remove(data.item)"
                  >
                    {{ data.item.label }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex v-if="incidencia.Estado === 'C'" :class="[fullForm ? 'py-1 xs12 sm6 md7 lg8': 'py-1 xs12 md8']">
              <v-autocomplete v-model="incidenciaPersonasContacto" readonly :items="personasContacto"
                              :filter="selectFilterIncludes" :attach="!fullForm" label="Personas de Contacto" item-text="label"
                              item-value="value" class="mt-1" multiple chips small-chips
                              hide-details :auto-select-first="true" @input="setReportadaPor"
              >
                <template v-slot:selection="data">
                  <v-chip :selected="data.selected"
                          @click.stop="copyEmail($event)"
                  >
                    {{ data.item.label }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']">
              <v-autocomplete v-model="incidencia.Programa" :disabled="isDisabled" :items="Programas" :filter="selectFilterIncludes"
                              :error="!checkPrograma(incidencia.Programa)"
                              :attach="!fullForm" label="Programa" item-text="label" item-value="value"
                              class="mt-1 select-inline" clearable hide-details :auto-select-first="true"
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.label }}</span>
                  <v-icon v-if="!item.Mantenimiento" color="error" class="icon-error mr-1">
                    mdi-alert
                  </v-icon>
                  <v-icon v-else-if="item.BolsaDeHoras" color="warning" class="icon-error mr-1">
                    mdi-clock-alert
                  </v-icon>
                </template>
                <template v-slot:item="{ item }">
                  <div class="item-flex">
                    <span>{{ item.label }}</span>
                    <v-icon v-if="!item.Mantenimiento" color="error" class="mr-1">
                      mdi-alert
                    </v-icon>
                    <v-icon v-else-if="item.BolsaDeHoras" color="warning" class="mr-1">
                      mdi-clock-alert
                    </v-icon>
                  </div>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']">
              <v-autocomplete v-model="incidencia.TipoIncidencia" :disabled="isDisabled" :items="TiposIncidencias"
                              :filter="selectFilterIncludes" :attach="!fullForm" label="Tipo incidencia"
                              item-text="label" item-value="value" class="mt-1 select-inline" clearable
                              hide-details :auto-select-first="true"
              />
            </v-flex>
            <v-flex v-if-tecnico :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']">
              <v-autocomplete v-model="incidencia.Prioridad" :disabled="isDisabled" :items="Prioridades"
                              :filter="selectFilterIncludes" :attach="!fullForm" label="Prioridad" item-text="label"
                              item-value="value" class="mt-1 select-inline" clearable hide-details :auto-select-first="true"
              />
            </v-flex>
          </v-layout>

          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex v-if="fullForm || !incidencia.TecnicoRecepcion" v-if-tecnico
                    :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']"
            >
              <v-autocomplete
                v-model="incidencia.TecnicoRecepcion"
                :disabled="isDisabled"
                :items="Tecnicos"
                :filter="selectFilterIncludes"
                :attach="!fullForm"
                label="Recibida por"
                item-text="label"
                item-value="value"
                class="mt-1 select-inline"
                clearable
                hide-details
                :auto-select-first="true"
              />
            </v-flex>
            <v-flex
              v-if="fullForm ||(!fullForm && $store.getters.Tecnico)"
              :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']"
            >
              <v-autocomplete
                v-model="incidencia.TecnicoAsignado"
                :disabled="isDisabledOrNotTecnico"
                :items="Tecnicos"
                :filter="selectFilterIncludes"
                :attach="!fullForm"
                label="Asignada a"
                item-text="label"
                item-value="value"
                class="mt-1 select-inline"
                clearable
                hide-details
                :auto-select-first="true"
              />
            </v-flex>
            <v-flex v-if-tecnico :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']">
              <v-text-field
                v-model="incidencia.ReferenciaIncidenciaCliente"
                :disabled="isDisabled"
                label="Ref.cliente"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex v-if="fullForm ||(!fullForm && $store.getters.Tecnico)"
                    :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3': 'py-1 xs12 md4']"
            >
              <v-date v-model="incidencia.FechaProximoAviso" label="Fecha próximo aviso" class="mt-3" />
            </v-flex>
          </v-layout>

          <v-layout v-if="fullForm" align-space-between justify-start row fill-height wrap>
            <v-flex class="py-1 xs12 sm6 md4 lg3">
              <v-text-field
                v-if="isNotTecnicoAndDisabledOrEmpty(incidencia.Presupuesto)"
                v-model="incidencia.Presupuesto"
                :disabled="isDisabled"
                label="Presupuesto"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex class="py-1 xs12 sm6 md4 lg3">
              <v-text-field
                v-if="isNotTecnicoAndDisabledOrEmpty(incidencia.Albaran)"
                v-model="incidencia.Albaran"
                :disabled="isDisabled"
                label="Nº de albarán"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex v-if-tecnico class="py-1 xs12 sm6 md4 lg3">
              <v-checkbox
                v-if="isNotTecnicoAndDisabledOrEmpty(incidencia.DescontarHoras)"
                v-model="incidencia.DescontarHoras"
                :disabled="isDisabled"
                :toggle-indeterminate="false"
                label="Descontar horas de la bolsa de horas del cliente"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex v-if-tecnico class="py-1 xs12 sm6 md4 lg3">
              <v-checkbox
                v-model="incidencia.NotificableBoletin"
                :disabled="isDisabled"
                :toggle-indeterminate="false"
                label="Notificar en el boletín de actualizaciones"
                class="mt-1"
              />
            </v-flex>
          </v-layout>

          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12' : 'py-1 xs12']">
              <v-textarea
                v-model="incidencia.Descripcion"
                :max-height="60"
                :hide-details="!fullForm"
                rows="4"
                label="Descripción"
                class="mt-0"
              />
            </v-flex>
          </v-layout>

          <v-layout v-if-tecnico align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12' :'py-1 xs12']">
              <v-textarea
                v-model="incidencia.Observaciones"
                :disabled="isDisabled"
                :max-height="25"
                :hide-details="!fullForm"
                rows="2"
                label="Observaciones"
                class="mt-0"
              />
            </v-flex>
          </v-layout>

          <v-layout v-if-tecnico align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12' :'py-1 xs12']">
              <v-textarea
                v-model="incidencia.DescripcionTecnica"
                :disabled="isDisabled"
                :max-height="25"
                :hide-details="false"
                :counter="160"
                :rules="[v => !v || v.length <= 160 || 'Máximo 160 caracteres']"
                maxlength="160"
                rows="2"
                label="Descripción técnica"
                class="mt-0"
              />
            </v-flex>
          </v-layout>

          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12' :'py-1 xs12']">
              <drive
                ref="drive"
                :cliente="incidencia.Cliente"
                :instalacion="incidencia.Instalacion"
                :incidencia="incidencia.Incidencia"
                :disabled="isDisabled"
              />
            </v-flex>
          </v-layout>

          <v-layout v-if="fullForm" justify-center row fill-height class="pt-0 pb-1 text-center">
            <partes
              ref="partes"
              :cliente="incidencia.Cliente"
              :instalacion="incidencia.Instalacion"
              :incidencia="incidencia.Incidencia"
              :estado="incidencia.Estado"
            />
          </v-layout>

          <v-layout
            align-space-between
            justify-center
            row
            fill-height
            wrap
            class="pt-3 pb-1 text-center"
          >
            <template v-if="!fullForm">
              <v-btn color="success" @click="modify(false)">
                <v-icon>mdi-content-save</v-icon>Guardar
              </v-btn>
              <span style="position: absolute;right: 0;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if-tecnico
                      color="brown darken-1"
                      dark
                      fab
                      small
                      v-on="on"
                      @click="incidencia.AnclaFecha = !incidencia.AnclaFecha"
                    >
                      <v-icon>{{ incidencia.AnclaFecha ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ incidencia.AnclaFecha ? 'Desanclar' : 'Anclar' }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if-tecnico
                      color="yellow darken-1"
                      fab
                      light
                      small
                      v-on="on"
                      @click="incidencia.SeguimientoFecha = !incidencia.SeguimientoFecha"
                    >
                      <v-icon>{{ incidencia.SeguimientoFecha ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ incidencia.SeguimientoFecha ? 'Desmarcar como seguimiento' : 'Marcar como seguimiento' }}</span>
                </v-tooltip>
              </span>
            </template>
            <template v-else-if="incidencia.Estado !== 'A' && incidencia.Estado !== 'C'">
              <v-menu
                open-on-hover
                top
                nudge-top="34"
                transition="fade-transition"
                content-class="elevation-0"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="success" v-on="on" @click="modify(false, 'exit')">
                    <v-icon class="mr-2">
                      mdi-content-save
                    </v-icon>Guardar
                  </v-btn>
                </template>
                <v-list class="small-list success py-0" dark>
                  <v-list-tile @click="modify(false)">
                    Guardar sin salir
                  </v-list-tile>
                </v-list>
              </v-menu>

              <div v-if-tecnico>
                <v-menu
                  open-on-hover
                  top
                  nudge-top="34"
                  transition="fade-transition"
                  content-class="elevation-0"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="white--text deep-purple darken-1"
                      v-on="on"
                      @click="modify(true, 'exit')"
                    >
                      <v-icon class="mr-2">
                        mdi-lock
                      </v-icon>Cerrar
                    </v-btn>
                  </template>
                  <v-list class="small-list white--text deep-purple darken-1 py-0" dark>
                    <v-list-tile @click="modify(true)">
                      Cerrar sin salir
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <inner-loading :visible="loading" :class="[fullForm ? 'ma-4' : '']" />

    <actions-incidencias
      v-if="fullForm"
      :cliente="incidencia.Cliente"
      :instalacion="incidencia.Instalacion"
      :incidencia="incidencia.Incidencia"
      :tecnico-asignado="incidencia.TecnicoAsignado"
      :ancla-fecha="incidencia.AnclaFecha"
      :seguimiento-fecha="incidencia.SeguimientoFecha"
      :observaciones="incidencia.Observaciones"
      :estado="incidencia.Estado"
      :telefonos="telefonos"
    />
  </v-container>
</template>

<script>
import ActionsIncidencias from '@/components/floatingActions/incidencias/Actions'
import InnerLoading from '@/components/InnerLoading'
import { Entities, Forms } from '@/mixins/index.js'
import { EventBus } from '@/store/EventBus.js'
import Partes from '@/pages/partes/index.vue'
import DateTime from '@/components/DateTime'
import CopyChip from '@/components/CopyChip'
import moment from 'moment'
import VDate from '@/components/VDate'
import Drive from '@/components/Drive'

export default {
  name: 'IncidenciasEdit',
  components: { Partes, DateTime, InnerLoading, ActionsIncidencias, VDate, Drive },
  mixins: [Entities, Forms],
  props: {
    clienteProp: { type: [String, Number], default: '0' },
    instalacionProp: { type: [String, Number], default: '0' },
    incidenciaProp: { type: [String, Number], default: '0' },
    fullForm: { type: Boolean, default: true },
    emitReload: { type: Boolean, default: true }
  },
  data () {
    return {
      actionsIncidencias: ActionsIncidencias,
      incidencia: {},
      instalacion: null,
      instalacionDetalles: '',
      incidenciaPersonasContacto: [],
      personasContacto: [],
      loading: false,
      reload: false,
      isNew: true,
      estadoAnterior: '',
      telefonos: [],
      textCopied: '¡Email Copiado!',
      files: ''
    }
  },
  metaInfo () {
    return {
      title: (this.isNew ? `Nueva Incidencia` : `Incidencia ${this.instalacion}/${this.incidencia.Incidencia}`) + ' - Sopheo' }
  },
  computed: {
    loadInstalaciones () {
      if (this.incidencia.Cliente) {
        let instalaciones =
          this.filterBy('instalacion', `${this.incidencia.Cliente}/`) || []
        return instalaciones
      } else {
        return this.Instalaciones
      }
    },
    isDisabled () {
      return (
        this.incidencia.Estado === 'C' ||
        this.incidencia.Estado === 'A' ||
        (!!this.incidencia.Incidencia && !this.$store.getters.Tecnico)
      )
    },
    isDisabledOrNotTecnico () {
      return this.isDisabled || !this.$store.getters.Tecnico
    },
    isDisabledDescripcion () {
      return (
        this.incidencia.Estado === 'C' ||
    this.incidencia.Estado === 'A'
      )
    }
  },
  watch: {
    incidencia: {
      handler: function (value) {
        if (this.fullForm && !this.loading) {
          this.$store.dispatch('AskToLeave', true)
        }
      },
      deep: true
    },
    loading: function (value) {
      if (
        !value &&
        this.incidencia.Programa &&
        this.checkPrograma(this.incidencia.Programa, 'BolsaDeHoras')
      ) {
        this.incidencia.DescontarHoras = true
      }
    },
    'incidencia.Programa': function (value) {
      if (!this.loading) {
        this.incidencia.DescontarHoras = false
        if (value && this.checkPrograma(value, 'BolsaDeHoras')) {
          this.incidencia.DescontarHoras = true
        }
      }
    },
    'incidencia.Cliente': function (value) {
      if (this.fullForm) {
        this.$store.dispatch('entities/SET_CLIENTE', value)
      }
      if (this.loadInstalaciones.length === 1) {
        this.instalacion = this.loadInstalaciones[0].value
      }
      if (!value) {
        this.instalacion = null
      }
    },
    instalacion: function (value) {
      if (value) {
        this.incidencia.Cliente = parseInt(value.split('/')[0])
        if (this.fullForm) {
          this.$store.dispatch(
            'entities/SET_INSTALACION',
            value.split('/').pop()
          )
        }
      }
      this.incidencia.Instalacion = value
        ? parseInt(value.split('/').pop())
        : null
      this.loadProgramas()
      this.loadPersonasContacto()
      this.loadInstalacionDetalles()
    }
  },
  mounted () {
    this.loadIncidencia()
    setTimeout(() => {
      this.asyncClientes(!this.incidencia.Cliente)
      this.asyncInstalaciones(!this.incidencia.Cliente)
      this.asyncIncidenciaEstados()
      this.asyncTiposIncidencias()
      // this.asyncProgramas()
      this.asyncPrioridades()
      this.asyncTecnicos()
    }, 10)
    if (this.fullForm) {
      EventBus.$on('reloadRequest', this.loadIncidencia)
      this.$watch(
        '$refs.partes.partes',
        () => {
          if (!this.$refs.partes.loading) { this.$store.dispatch('AskToLeave', true) }
        },
        { deep: true }
      )
    }
  },
  beforeDestroy () {
    this.close()
  },
  methods: {
    moment,
    isNotTecnicoAndDisabledOrEmpty (val) {
      return (
        this.$store.getters.Tecnico ||
        (!this.$store.getters.Tecnico && (this.isDisabled || val))
      )
    },
    close () {
      this.loading = false
      if (this.fullForm) {
        this.$store.dispatch('AskToLeave', false)
        this.$store.dispatch('entities/SET_CLIENTE', null)
        this.$store.dispatch('entities/SET_INSTALACION', null)
        // EventBus.$emit('newFloatingActions', null)
        EventBus.$off('reloadRequest', this.loadIncidencia)
      } else {
        EventBus.$emit('closeModal', true)
        if (this.reload) {
          EventBus.$emit('reloadRequest')
        }
      }
    },
    loadIncidencia (Cliente = null, Instalacion = null, Incidencia = null) {
      this.loading = true

      this.incidencia = Object.assign(
        {},
        this.$store.getters['entities/getIncidencia']
      )
      this.incidencia.FechaIncidencia = Date.now()
      this.incidencia.Cliente = Cliente || Number(this.clienteProp) || null
      this.incidencia.Instalacion =
        Instalacion || Number(this.instalacionProp) || null

      if (!this.$store.getters.Tecnico && !this.incidencia.Cliente) {
        this.incidencia.Cliente = this.$store.getters['getClient']
        this.incidencia.Instalacion = this.$store.getters['getInstalacion']
      }

      this.incidencia.Incidencia =
        Incidencia || Number(this.incidenciaProp) || 0
      this.incidencia.Prioridad = this.$store.getters['getPrioridad']

      if (!this.$store.getters.Tecnico) {
        // this.incidencia.Instalacion = Instalacion || null
        this.incidencia.TecnicoRecepcion = 0
        this.incidencia.TecnicoAsignado = 0
      } else {
        this.incidencia.TecnicoRecepcion = this.$store.getters['getTecnico']
      }
      if (this.incidencia.Cliente && !!this.incidencia.Instalacion) {
        this.instalacion = `${this.incidencia.Cliente}/${
          this.incidencia.Instalacion
        }`
      }
      if (this.fullForm) {
        setTimeout(() => {
          this.$store.dispatch('AskToLeave', false)
          // EventBus.$emit('newFloatingActions', ActionsIncidencias)
        }, 500)
      }
      if (
        this.incidencia.Cliente &&
        !!this.incidencia.Instalacion &&
        this.incidencia.Incidencia
      ) {
        this.axios
          .get(
            `${this.$apiUrl('incidencia')}?cliente=${
              this.incidencia.Cliente
            }&instalacion=${this.incidencia.Instalacion}&incidencia=${
              this.incidencia.Incidencia
            }`,
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(({ data }) => {
            this.incidencia = data
            this.instalacion = `${this.incidencia.Cliente}/${
              this.incidencia.Instalacion
            }`
            this.isNew = false
            if (this.fullForm) {
              if (this.$refs.partes) {
                this.$refs.partes.request({})
              }
              this.loadToolbarTitle(this.incidencia.Incidencia)
              this.$refs.drive.loadChips(this.incidencia.Cliente, this.incidencia.Instalacion, this.incidencia.Incidencia)
              setTimeout(() => {
                this.$store.dispatch('AskToLeave', false)
              }, 1500)
            }
          })
          .catch(() => {
            this.$router.push({ name: 'incidencias' })
            this.incidencia.Incidencia = 0
          })
          .then(() => {
            this.loading = false
          })
      } else {
        this.loading = false
        this.$refs.cliente.focus()
      }
      this.loadToolbarTitle()
    },
    loadToolbarTitle (incidencia = 0) {
      if (!this.fullForm) return
      let self = this
      let toolbarTitle = {
        template: `
          <span>
            <v-btn :to="{name: 'incidencias'}" icon exact class="mr-2">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="!incidencia">Nueva Incidencia</span>
            <template v-else><span>Nº Incidencia :&nbsp;</span>
              <copy-chip :text="cliente+'/'+instalacion+'/'+incidencia"/>
            </template>
          </span>`,
        components: { CopyChip },
        data () {
          return {
            cliente: self.incidencia.Cliente,
            instalacion: self.incidencia.Instalacion,
            incidencia: incidencia
          }
        }
      }
      EventBus.$emit('newToolbarTitle', toolbarTitle)
    },
    loadProgramas () {
      this.Programas = []
      this.incidencia.Programa = null
      if (this.incidencia.Cliente && this.incidencia.Instalacion) {
        this.getProgramaBy(
          this.incidencia.Cliente,
          this.incidencia.Instalacion
        )
      }
    },
    loadInstalacionDetalles () {
      if (!this.fullForm) return
      this.instalacionDetalles = ''
      this.telefonos = []
      if (this.incidencia.Cliente && this.incidencia.Instalacion) {
        this.axios
          .get(
            `${this.$apiUrl('instalacion')}?cliente=${
              this.incidencia.Cliente
            }&instalacion=${this.incidencia.Instalacion}`,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(({ data }) => {
            if (data.Telefono1) {
              this.telefonos.push(data.Telefono1.replace(/ |-/g, ''))
            }
            if (data.Telefono2) {
              this.telefonos.push(data.Telefono2.replace(/ |-/g, ''))
            }
            this.instalacionDetalles = `Email:  ${data.Email ||
              ''}\nTelefono1:  ${data.Telefono1 ||
              ''}\nTelefono2:  ${data.Telefono2 || ''}\nWeb:  ${data.Web ||
              ''}\n`
            this.instalacionDetalles += `Observaciones:  ${data.Observaciones ||
              ''}\n`
            this.instalacionDetalles += `ObservacionesEspeciales:  ${data.ObservacionesEspeciales ||
              ''}\n`
            this.showObservacionesEspeciales(data.ObservacionesEspeciales)
          })
          .catch(() => {})
      }
    },
    showObservacionesEspeciales (message = '') {
      if (message) {
        this.$root.$confirm.open('Observaciones Especiales', message, {
          messageStyle: 'white-space: pre-wrap;',
          preventClose: true,
          color: 'purple darken-1',
          ok: { color: 'purple darken-1', autofocus: true, flat: false }
        })
      }
    },
    /*
    loadFiles () {
      this.files = []
      this.axios
        .get(
          `${this.$apiUrl('file')}?cliente=${this.incidencia.Cliente}&instalacion=${this.incidencia.Instalacion}&incidencia=${this.incidencia.Incidencia}`,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(({ data }) => {
          this.$refs.drive.getFiles(data)
          for (let i = 0; i < data.length; i++) {
            this.files.push(data[i])
          }
        })
    }, */
    loadPersonasContacto () {
      this.personasContacto = []
      this.incidenciaPersonasContacto = []
      if (this.incidencia.Cliente && this.incidencia.Instalacion) {
        let incidencia = this.incidencia.Incidencia
          ? `&incidencia=${this.incidencia.Incidencia}`
          : ''
        this.axios
          .get(
            `${this.$apiUrl('personaContacto')}?cliente=${
              this.incidencia.Cliente
            }&instalacion=${this.incidencia.Instalacion}${incidencia}`,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(({ data }) => {
            if (data && data.data) {
              this.personasContacto = this.$loadSelect(
                data.data,
                ['Nombre', 'CorreoElectronico'],
                ['Cliente', 'Instalacion', 'NumeroOrden']
              )
              this.incidenciaPersonasContacto =
                data.data
                  .filter(p => p.Seguimiento)
                  .map(p => {
                    return (
                      p['Cliente'] +
                      '/' +
                      p['Instalacion'] +
                      '/' +
                      p['NumeroOrden']
                    )
                  }) || []
            }
          })
          .catch(() => {})
      }
    },
    setReportadaPor (personaContacto) {
      if (personaContacto) {
        personaContacto = this.personasContacto.find(
          x => x.value === personaContacto[0]
        )
        if (
          personaContacto &&
          personaContacto.label &&
          !this.incidencia.ReportadaPor
        ) {
          this.incidencia.ReportadaPor = personaContacto.label.replace(
            / *\([^)]*\) */g,
            ''
          )
        }
      }
    },
    copyEmail (event) {
      let regex = /\(([^)]+)\)/
      let matches = regex.exec(event.target.childNodes[0].textContent)
      let aux = document.createElement('input')
      aux.setAttribute('value', matches[1])
      document.body.appendChild(aux)
      aux.select()
      try {
        document.execCommand('copy')
        document.body.removeChild(aux)
        const original = event.target.textContent
        event.target.childNodes[0].textContent = this.textCopied
        setTimeout(() => {
          event.target.childNodes[0].textContent = original
        }, 1300)
      } catch (e) { }
    },
    remove (item) {
      const index = this.incidenciaPersonasContacto.indexOf(item.value)
      if (index >= 0) this.incidenciaPersonasContacto.splice(index, 1)
    },
    async modify (cerrar, postAction) {
      // if (this.incidencia.Estado === 'C') return
      this.loading = true
      this.reload = false
      let method = 'put'
      let url = this.$apiUrl('incidencia')
      this.estadoAnterior = this.incidencia.Estado
      if (this.isNew) {
        this.incidencia.Estado = 'N'
        method = 'post'
        this.incidencia.AnclaFecha = this.incidencia.AnclaFecha
          ? moment(this.incidencia.FechaIncidencia).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          : null
        this.incidencia.SeguimientoFecha = this.incidencia.SeguimientoFecha
          ? moment(this.incidencia.FechaIncidencia).format(
            'YYYY-MM-DD HH:mm:ss'
          )
          : null
      } else {
        url += `?cliente=${this.incidencia.Cliente}&instalacion=${
          this.incidencia.Instalacion
        }&incidencia=${this.incidencia.Incidencia}`
      }

      this.incidencia.Trabajosrealizados = []
      if (this.$store.getters.Tecnico && this.$refs.partes) {
        this.incidencia.Trabajosrealizados = this.$refs.partes.partes || []
      }

      this.incidencia.IncidenciaPersonas =
        this.incidenciaPersonasContacto.map(item => {
          //  string.Format("{0:00000}{1:00000}{2:0000}", cliente, instalacion, persona.NumeroOrden);
          let _item = item.split('/')
          if (_item[0] && _item[1] && _item[2]) {
            let quePersona =
              ('00000' + _item[0]).slice(-5) +
              ('00000' + _item[1]).slice(-5) +
              ('0000' + _item[2]).slice(-4)
            return {
              Cliente: this.incidencia.Cliente,
              Instalacion: this.incidencia.Instalacion,
              Incidencia: 0,
              QuePersona: quePersona
            }
          } else {
            return null
          }
        }) || []

      let partesNotificados = this.incidencia.Trabajosrealizados.filter(
        parte => parte.Notificable
      )

      if (this.incidencia.Presupuesto) {
        let correoElect = []
        let emails = []
        let regexParentesis = /\(([^)]+)\)/
        let regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        this.incidenciaPersonasContacto.forEach((element) => {
          correoElect.push(this.personasContacto.filter(per => per.value === element))
        })

        correoElect.forEach((value) => {
          value.forEach((pr) => {
            let intParentesis = regexParentesis.exec(pr['label'])
            if (regexEmail.exec(intParentesis[1])) {
              emails.push(intParentesis[1])
            }
          })
        })

        if (!emails.length) {
          this.$notify({
            message:
            'La incidencia tiene que tener una persona de contacto con un email valido.',
            type: 'error'
          })
          this.loading = false
          return
        }
      }

      if (
        this.incidencia.TipoIncidencia === 10 &&
        (!this.incidencia.ReferenciaIncidenciaCliente ||
          this.incidencia.ReferenciaIncidenciaCliente.length === 0)
      ) {
        this.$notify({
          message:
            'Las incidencias HCB deben ir acompañadas de la referencia correspondiente.',
          type: 'error'
        })
        this.loading = false
        return
      }
      // === VALIDACIÓN PARA TÉCNICO 96 (creación y traspaso) ===
      if (
        this.incidencia.TecnicoAsignado === 96 &&
        (this.incidencia.Estado === 'N' || this.incidencia.Estado === 'P')
      ) {
        let errors = []

        // Validaciones solo para técnicos
        if (this.$store.getters.Tecnico) {
          if (!this.incidencia.DescripcionTecnica || this.incidencia.DescripcionTecnica.length === 0) {
            errors.push('La descripción técnica es obligatoria.')
          } else if (this.incidencia.DescripcionTecnica.length > 160) {
            errors.push('La descripción técnica no puede superar los 160 caracteres.')
          }

          const archivosNuevos = (this.$refs.drive && this.$refs.drive.files && this.$refs.drive.files.length) || 0
          const archivosExistentes = (this.$refs.drive && this.$refs.drive.$refs.chipsDrive && this.$refs.drive.$refs.chipsDrive.files && this.$refs.drive.$refs.chipsDrive.files.length) || 0
          if (archivosNuevos + archivosExistentes === 0) {
            errors.push('Debe adjuntar al menos un archivo.')
          }
        }

        // Validación común para técnicos y clientes
        if (!this.incidencia.Descripcion || this.incidencia.Descripcion.length === 0) {
          errors.push('La descripción es obligatoria.')
        }

        if (errors.length) {
          errors.forEach(msg => {
            this.$notify({ message: msg, type: 'error' })
          })
          this.loading = false
          return
        }
      }
      //  Si la incidencia tiene Trabajos realizados, el estado cambia a 'P' (Pendiente)
      if (
        this.incidencia.Trabajosrealizados.length &&
        this.incidencia.Estado === 'N'
      ) { this.incidencia.Estado = 'P' }
      // Si la incidencia se está guardando como Actualización Software,  el estado cambia a 'U' (Pend. Actualización)
      if (
        this.incidencia.TipoIncidencia === 8 &&
        this.incidencia.Estado !== 'C'
      ) { this.incidencia.Estado = 'U' }

      if (cerrar) {
        let message = []
        if (!this.incidencia.Trabajosrealizados.length) {
          message.push('Debe haber al menos una línea.')
        }
        if (
          this.incidencia.IncidenciaPersonas.length &&
          !partesNotificados.length
        ) {
          message.push(
            'Debe marcar al menos una línea como notificable al cliente.'
          )
        }
        if (
          this.incidencia.TecnicoAsignado === null ||
          this.incidencia.TecnicoAsignado === 0
        ) {
          message.push(
            `No puede cerrar una incidencia asignada a: "${this.findLabel(
              'tecnico',
              this.incidencia.TecnicoAsignado
            )}"`
          )
        }
        if (message.length) {
          message.forEach(key => {
            this.$notify({ message: key, type: 'error' })
          })
          this.loading = false
          return
        }

        if (!(await this.confirmCloseIncidencia())) {
          this.loading = false
          return
        } else this.incidencia.Estado = 'C'
      }

      this.incidencia.Trabajosrealizados = this.incidencia.Trabajosrealizados.map(
        parte => {
          parte.Cliente = this.incidencia.Cliente
          parte.Instalacion = this.incidencia.Instalacion
          parte.Fecha = moment(parte.Fecha).format('YYYY-MM-DD')
          return parte
        }
      )

      this.incidencia.FechaIncidencia = moment(
        this.incidencia.FechaIncidencia
      ).format('YYYY-MM-DD HH:mm:ss')

      if (this.incidencia.FechaProximoAviso) {
        this.incidencia.FechaProximoAviso = moment(
          this.incidencia.FechaProximoAviso
        ).format('YYYY-MM-DD')
      }

      this.axios({
        method: method,
        url: url,
        data: this.incidencia,
        headers: { contentType: 'application/json' }
      })
        .then(response => {
          this.loading = false
          this.reload = this.emitReload
          if (response.status === 207) {
            this.$notify({ message: response.statusText, type: 'warning' })
          }
          if (response.data) {
            let inci = ''
            if (
              response.data.Cliente &&
              response.data.Instalacion &&
              response.data.Incidencia
            ) {
              inci = `${response.data.Cliente}/${response.data.Instalacion}/${
                response.data.Incidencia
              }`
            }
            let message = ''
            let action = this.isNew ? 'creada' : 'modificada'
            if (
              this.isNew &&
              this.incidencia.Estado !== 'C' &&
              this.incidencia.Estado !== 'U'
            ) {
              message = `La Incidencia ha sido creada. ${inci}`
            } else if (this.incidencia.Estado === 'U') {
              message = `La Incidencia ha sido ${action}. ${inci}`
            } else if (this.incidencia.Estado === 'C') {
              message = `La Incidencia ha sido cerrada. ${inci}`
            } else {
              message = `La incidencia ha sido actualizada. ${inci}`
            }
            this.$notify({ message: message })
            this.$refs.drive.sendFiles(response.data.Incidencia, response.data.idCardTrello)
            if (this.fullForm) {
              this.$store.dispatch('AskToLeave', false)
              if (
                this.postAction({ action: postAction, toName: 'incidencias' })
              ) {
                if (!Number(this.incidenciaProp)) {
                  this.$router.push({
                    name: 'incidenciasEdit',
                    params: {
                      clienteProp: response.data.Cliente,
                      instalacionProp: response.data.Instalacion,
                      incidenciaProp: response.data.Incidencia
                    }
                  })
                } else {
                  this.loadIncidencia(
                    response.data.Cliente,
                    response.data.Instalacion,
                    response.data.Incidencia
                  )
                }
              }
            } else {
              this.close()
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.incidencia.Estado = this.estadoAnterior
        })
    },
    async confirmCloseIncidencia () {
      let action = false
      await this.$root.$confirm
        .open(
          'Va a cerrar la incidencia',
          '¿Está seguro de querer cerrar esta incidencia?',
          {
            preventClose: true,
            ok: { color: 'error', autofocus: true },
            cancel: true
          }
        )
        .then(() => {
          action = true
        })
        .catch(() => {})
      return action
    }
  }
}
</script>

<style>
.modalIncidencias {
  width: 70vw;
  max-width: 700px;
  min-width: 100%;
}
</style>
